import { useQuery } from '@tanstack/react-query';
import { queryContext } from '@routable/shared';
import { approverApi } from '../services/rules';
export const useApprovers = (searchInput = '') => useQuery({
    context: queryContext,
    queryKey: ['approvers', searchInput],
    queryFn: async () => approverApi.readAll(searchInput),
    refetchOnMount: 'always',
    select: (responseBody) => responseBody?.data || [],
});
